export function questionForAnswer(messages, answerIndex) {
  if (!Array.isArray(messages) || !Number.isInteger(answerIndex)) return "";
  for (let index = Math.min(answerIndex - 1, messages.length - 1); index >= 0; index -= 1) {
    if (messages[index]?.role === "user") return messages[index].content || "";
  }
  return "";
}
